<template>
  <div class="pay-record">
    充值记录大萨达撒大多撒大奥所多
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>

</style>